export { default } from 'features/reward/routes/rewards-profile-route';
